module.exports = __webpack_public_path__ + "img/is-new.7f0c4ece.svg";